import Component from '../colorz/Component';

export default class CustomerLoyalty extends Component {
	onInit(el) {
		this.el = el;
		this.points = this.el.querySelector('.js-points-info');
		this.tier = this.el.querySelector('.js-tier-info');
	}

	onReady() {
		this.fetchCustomerLoyalty();
	}

	fetchCustomerLoyalty() {
		fetch('/apps/clrz/customer-loyalty')
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
			})
			.then((data) => {
				let customerInfos = data;
				if (customerInfos) {
					this.displayInfos(customerInfos);
				}
			});
	}

	displayInfos(customerInfos) {
		if (customerInfos.points_balance) {
			this.points.innerHTML = customerInfos.points_balance;
		}

		if (customerInfos.current_tier != null) {
			this.tier.innerHTML = customerInfos.current_tier.title + ' - ';
		}
	}
}
